import { Link } from "wouter";
import { ArrowLeft, Search } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="min-h-[100dvh] flex items-center justify-center bg-[#f4f6f8] p-4">
      <div className="w-full max-w-md text-center">
        <p className="text-9xl font-extrabold text-muted-foreground/40 select-none leading-none mb-4">
          404
        </p>

        <div className="flex justify-center mb-5">
          <div className="h-14 w-14 rounded-full bg-blue-50 flex items-center justify-center">
            <Search className="h-7 w-7 text-blue-500" />
          </div>
        </div>

        <h1 className="text-xl font-bold text-foreground mb-2">Page not found</h1>
        <p className="text-sm text-muted-foreground mb-8">
          The page you're looking for doesn't exist or may have been moved.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button asChild>
            <Link href="/dashboard">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back to dashboard
            </Link>
          </Button>
          <Button variant="outline" asChild>
            <Link href="/">Home</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
